import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { EquipmentSelectionType } from '@/enums/EquipmentSelectionType';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

import { sortBy, intersection } from 'lodash-es';

@Block() @Component
export class ApartmentSpecialEquipmentBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	expand: boolean = !this.$store.isTouchDevice;
	isTouchDevice: boolean = this.$store.isTouchDevice;

	get specialEquipmentDescriptions() {
		return sortBy(this.apartment.specialEquipmentDescriptions, ['order']);
	}

	get showFloorsAndDoorsSelectionText() {
		return intersection(this.apartment.equipmentSelections.filter(es => es.selectionDate).map(es => es.type), [EquipmentSelectionType.Floors, EquipmentSelectionType.InnerDoors]).length == 0
			&& this.apartment.clientChangesDeadlines[2] /* termin3 */ != null && new Date(this.apartment.clientChangesDeadlines[2]) < new Date();
	}

	get webNote() {
		return (this.apartment.webNote || '').trim();
	}

	get blindsAndShutters() {
		return this.apartment.hasRollerBlinds || this.apartment.hasRollerBlindsInPart || this.apartment.hasRollerShutter || this.apartment.hasRollerShutterInPart
	}

	get hasRecovery() {
		return this.apartment.hasHeatRecovery || this.apartment.hasHeatRecoveryWithoutCooling
	}

	get showSectionSpecialEquioment() {
		return this.blindsAndShutters || this.hasRecovery || this.showFloorsAndDoorsSelectionText || this.webNote || this.apartment.hasAirCondition || this.apartment.hasKitchenCabinet || this.apartment.hasBuiltinWardrobe
	}

	created() {
		const mql = window.matchMedia("(pointer: coarse)");

		this.expand = !mql.matches
		this.isTouchDevice = mql.matches
	}

}

export default ApartmentSpecialEquipmentBlock;
